(() => {
  if (window.ctProductHalloweenOfferReady) return;
  window.ctProductHalloweenOfferReady = true;

  const fallbackCopy = (text) => {
    const input = document.createElement('textarea');
    input.value = text;
    input.setAttribute('readonly', '');
    input.style.position = 'fixed';
    input.style.opacity = '0';
    document.body.appendChild(input);
    input.select();
    const copied = document.execCommand('copy');
    input.remove();
    return copied;
  };

  const copyCode = async (button) => {
    const code = button.dataset.ctHalloweenCopy;
    let copied = false;

    try {
      await navigator.clipboard.writeText(code);
      copied = true;
    } catch (_error) {
      copied = fallbackCopy(code);
    }

    if (!copied) return;

    const offer = button.closest('[data-ct-halloween-offer]');
    const label = button.querySelector('[data-ct-halloween-copy-label]');
    const status = offer && offer.querySelector('[data-ct-halloween-copy-status]');

    button.dataset.copied = 'true';
    if (label) label.textContent = 'Copied';
    if (status) status.textContent = `Discount code ${code} copied.`;

    window.setTimeout(() => {
      delete button.dataset.copied;
      if (label) label.textContent = 'Copy';
      if (status) status.textContent = '';
    }, 1800);
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ct-halloween-copy]');
    if (button) copyCode(button);
  });
})();
